export type IResetForm = (form: HTMLFormElement | JQuery<HTMLFormElement>) => void;

export function resetForm(form: HTMLFormElement | JQuery<HTMLFormElement>): void {
  const $form = $(form);
  const $inputs = $form.find('input[type="text"]');
  const $textareas = $form.find('textarea');
  const $selects = $form.find('select');
  const $radio = $form.find('input[type="checkbox"], input[type="radio"]');
  const $summernote = $form.find('.note-editable');

  $inputs.val('').trigger('change');
  $textareas.val('').trigger('change');
  $summernote.html('').trigger('change');
  $selects.val('').trigger('change');
  $radio.prop('checked', false).trigger('change');
}
